export function uid(len = 40) {
    var str = '',
        possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    len = len || 10;

    while (len) {
        str += possible.charAt(Math.floor(Math.random() * possible.length));
        len--;
    }

    return str;
}
